/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/userLists.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_USER_LIST } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUserListsMethods extends IPluginMethodMap {
  getUserListsProps(args: any): Promise<any>;
}

export class UserListsService implements IAgentPlugin {
  readonly methods: IUserListsMethods;

  constructor() {
    this.methods = {
      getUserListsProps: this.getUserListsProps.bind(this),
    };
  }

  async getUserListsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_USER_LIST,
          variables: {
            options: {
              skip: args?.offset ?? 0,
              limit: args?.size ?? 10,
            },
            filters: {
              ...args?.criteria,
              role__in: "fe93dab0-424b-4aa3-9efa-c001b4c03013",
            },
            // input: {
            //   criteria: {},
            //   size: 200,
            //   offset: 0,
            // },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _totalPages = res?.data?.getUsersWithBoxes?.count
            ? parseInt(res?.data?.getUsersWithBoxes?.count) / 10
            : 1;
          let _currentPage =
            res?.data?.getUsersWithBoxes?.skip /
              res?.data?.getUsersWithBoxes?.limit +
            1;
          let _rowData = this.formatUserTable(
            res?.data?.getUsersWithBoxes?.content,
            res?.data?.getListOfRole?.data
          );
          console.log(`row data`, _rowData);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getUsersWithBoxes?.content?.length <= 0,
            // studentGroup: holderGroups,
            activePage: _currentPage,
            pageSize: res?.data?.getUsersWithBoxes?.limit,
            totalCount: res?.data?.getUsersWithBoxes?.count,
            totalPages: _totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private _getRoles = (role: any, roles: any) => {
    let _res: any[] = [];
    roles &&
      Array.isArray(roles) &&
      roles.length > 0 &&
      roles.map((item: any, index: number) => {
        role &&
          Array.isArray(role) &&
          role.length > 0 &&
          role.map((ele: any, eleindex: number) => {
            if (ele === item?.uuid) {
              _res.push(item?.name);
            }
          });
      });

    return _res;
  };

  private formatUserTable(data: any, roles: any[]) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          id: item?.id,
          vuid: item?.vuid,
          // status: item?.status,
          status: this.getFormattedStatus(item?.accountStatus, item?.suspended),
          name: `${item?.firstName} ${item?.lastName}`,
          email: item?.email,
          group: item?.group,
          image: item?.img,
          verified: item?.emailVerified,
          role: this._getRole(item?.role),
        };
      });

    return _rowData;
  }

  private _getRole(roles: any[]) {
    let _res: any[] = [];
    roles &&
      Array.isArray(roles) &&
      roles.length > 0 &&
      roles.map((item: any, index: number) => {
        _res.push(item?.name);
      });
    return _res;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format("LLL");
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return "suspended";
    } else {
      switch (status) {
        case "USER_ADDED":
          return "created";
        case "USER_INVITED":
          return "invited";
        case "USER_VERIFIED":
          return "verified";
        case "USER_ACC_CREATED":
          return "active";
        case "SUSPENDED":
          return "suspended";
        default:
          return "-";
      }
    }
  }
}
